module.exports = __webpack_public_path__ + "img/logo-menu.0f2636b6.png";